<template>
  <div id="my-app">
    <header :style="{backgroundColor: data.setup.css.primaryBg}">
      <h1 v-if="!showLogo">{{data.setup.companyNameShort}}</h1>
      <img
        v-if="showLogo"
        :style="{height: data.setup.css.logoHeight}"
        :src="data.setup.logoUrl"
      />
    </header>

    <section id="staff-img" :style="{backgroundColor: data.setup.css.primaryBg}">
      <img id="avatar" :src="data.record.staffImg" alt="Сотрудник"/>
    </section>

    <section id="staff-name" :style="{backgroundColor: data.setup.css.primaryBg}">
      <p>{{data.record.staffName}}</p>
    </section>

    <nav :style="{backgroundColor: data.setup.css.primaryBg}">
      <div class="tab tab1" :class="{active:selectedTab == 1}" @click="selectedTab = 1">
        <div>
          <svg viewBox="0 0 24 24">
            <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"/>
          </svg>
        </div>
        <div class="icon-label">инфо</div>
      </div>
      <div class="tab tab2" :class="{active:selectedTab == 2}" @click="selectedTab = 2">
        <div>
          <svg viewBox="0 0 24 24">
            <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
          </svg>
        </div>
        <div class="icon-label">контакты</div>
      </div>
      <div class="tab tab3" :class="{active:selectedTab == 3}" @click="selectedTab = 3">
        <div>
          <svg viewBox="0 0 24 24">
            <path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z" />
          </svg>
        </div>
        <div class="icon-label">адрес</div>
      </div>
      <div class="indicator"></div>
    </nav>

    <div :style="contentMargin" class="tabcontent" v-if="selectedTab === 1">
      <div class="info-row" v-if="!this.data.isExpired">
        <span>{{message}}</span>
      </div>
      <div class="info-row">
        <span>
          <svg viewBox="0 0 24 24">
            <path d="M7,10H12V15H7M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" />
          </svg>
        </span>
        <span>{{data.record.visitDateText}}</span>
        <span style="margin-left:50px;">
          <svg viewBox="0 0 24 24">
            <path d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z" />
          </svg>
        </span>
        <span>{{data.record.visitTime}}</span>
      </div>
      <div class="info-row">
        <span>
          <svg viewBox="0 0 24 24">
            <path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" />
          </svg>
        </span>
        <span>
          <span v-for="service of data.record.services" :key="service.title">
            {{ service.title }}
            <br>
          </span>
        </span>
      </div>
      <div class="info-row">
        <span>
          <svg viewBox="0 0 24 24">
            <path d="M3,6H21V18H3V6M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M7,8A2,2 0 0,1 5,10V14A2,2 0 0,1 7,16H17A2,2 0 0,1 19,14V10A2,2 0 0,1 17,8H7Z" />
          </svg>
        </span>
        <span>{{data.record.totalPrice}}{{data.setup.currencyFormat}}</span>
      </div>
    </div>

    <div :style="contentMargin" class="tabcontent" v-if="selectedTab === 2">
      <SocialButton
        v-for="item in data.setup.contactButtons"
        :key="item.btnType"
        :link="item.link"
        :btn-type="item.btnType"
        :bg-color="data.setup.css.socialBtn"
      />
    </div>

    <div :style="contentMargin" class="tabcontent" v-if="selectedTab === 3">
      <div class="info-row" v-if="data.setup.infoPlace">
        <span>
          <svg viewBox="0 0 256 256">
            <g transform="translate(0,256) scale(0.1,-0.1)">
              <path d="M1050 2551 c-30 -5 -84 -16 -120 -26 -432 -121 -786 -482 -901 -921 -21 -81 -24 -110 -24 -324 0 -215 3 -243 24 -325 105 -402 414 -743 803 -888 147 -55 196 -62 453 -62 231 0 244 1 340 28 210 58 435 194 587 355 72 77 198 249 198 271 0 6 3 11 8 11 4 0 12 12 19 28 6 15 23 52 36 83 37 85 62 174 77 279 11 76 12 362 0 435 -16 106 -38 194 -51 210 -5 5 -9 15 -9 23 0 27 -84 188 -143 276 -179 262 -424 437 -737 527 -64 18 -107 21 -290 24 -118 2 -240 0 -270 -4z m475 -66 c373 -81 679 -313 847 -641 83 -162 125 -319 135 -510 31 -603 -383 -1131 -987 -1261 -117 -25 -362 -25 -477 0 -502 108 -863 470 -970 971 -24 111 -24 361 0 472 53 249 153 438 326 616 192 199 421 319 696 364 100 17 333 11 430 -11z"/>
              <path d="M163 1523 c4 -120 7 -329 7 -465 l0 -248 396 0 396 0 154 -152 c85 -84 160 -155 165 -157 6 -2 78 67 161 153 l149 156 402 2 402 3 3 463 2 462 -429 0 -429 0 -127 -137 c-70 -76 -130 -139 -134 -141 -4 -1 -67 61 -140 138 l-133 140 -425 0 -426 0 6 -217z m975 34 l142 -144 83 86 c46 47 107 112 137 144 l53 57 396 -2 396 -3 0 -415 0 -415 -385 -2 -385 -2 -147 -153 -147 -153 -153 153 -153 152 -378 0 -377 0 0 420 0 420 388 0 388 0 142 -143z"/>
              <path d="M270 1275 l0 -365 345 0 345 0 0 45 c0 25 3 45 7 45 4 0 76 -69 160 -152 l153 -153 148 148 c81 81 151 147 155 147 4 0 7 -18 7 -40 l0 -40 350 0 350 0 0 365 0 365 -357 0 -358 1 -147 -153 -147 -153 -153 153 -153 152 -353 0 -352 0 0 -365z"/>
            </g>
          </svg>
        </span>
        <span>{{data.setup.infoPlace}}</span>
      </div>

      <div class="info-row" v-if="data.setup.infoAddressMain">
        <span>
          <svg viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
          </svg>
        </span>
        <span>{{data.setup.infoAddressMain}}</span>
      </div>

      <div class="info-row" v-if="data.setup.infoAddressAdditional">
        <span>
          <svg style="fill: white;" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
          </svg>
        </span>
        <span>{{data.setup.infoAddressAdditional}}</span>
      </div>

      <div class="info-row" style="justify-content: space-around;" v-if="data.setup.mapLink">
        <a style="margin: 0 -0.625em;" :href="data.setup.mapLink" target="_blank">
          <img style="width:100%;border: 0;" :src="data.setup.mapStatic" alt="" />
        </a>
      </div>
    </div>

    <section id="footer" v-if="this.data.record.visitStatus === 'waiting' && !this.data.isExpired">
      <a :style="{backgroundColor: data.setup.css.confirmBtn}" class="btn" @click="confirm(true)">Да, буду</a>
      <a :style="{backgroundColor: data.setup.css.cancelBtn}" class="btn" @click="confirm(false)">Отмените</a>
    </section>

    <ReschedulePopUp
      v-model="rescheduleAvailable"
      :primary-color="data.setup.css.confirmBtn"
      :secondary-color="data.setup.css.cancelBtn"
      :url="data.setup.rescheduleLink"
    />

    <LoadingSpinner v-if="dialogConfirm"
      v-model="dialogConfirm"
      v-on:spinnerClosed="onSpinnerClosed"
      :is-loading="isLoading"
      :bg-color="bgColor"
    />
  </div>
</template>

<script>
import axios from 'axios'

import SocialButton from '../components/SocialButton'
import LoadingSpinner from '../components/LoadingSpinner'
import ReschedulePopUp from '../components/ReschedulePopUp'

export default {
  components: {
    SocialButton,
    LoadingSpinner,
    ReschedulePopUp
  },
  data: () => ({
    lastBtnClicked: 'confirm',
    dialogConfirm: false,
    rescheduleAvailable: false,
    isLoading: false,
    bgColor: '',
    selectedTab: 1
  }),
  props: {
    data: {}
  },
  computed: {
    contentMargin () {
      if (this.data.record.visitStatus === 'waiting' && !this.data.isExpired) {
        return 'margin-bottom: 50px;'
      } else {
        return 'margin-bottom: 0px;'
      }
    },
    showLogo () {
      try {
        return this.data.setup.logoUrl !== undefined && this.data.setup.logoUrl !== ''
      } catch (e) {
        return false
      }
    },
    message () {
      if (this.data.record.visitStatus === 'confirmed') {
        return 'Вы подтвердили запись'
      } else if (this.data.record.visitStatus === 'canceled') {
        return 'Вы отменили запись'
      } else if (this.data.record.visitStatus === 'error') {
        return 'Произошла какая-то ошибка'
      } else {
        return this.data.setup.confirmationMessage
      }
    }
  },
  methods: {
    onSpinnerClosed: function () {
      if (this.lastBtnClicked === 'cancel' && this.data.setup.rescheduleLink !== '' && this.data.setup.rescheduleLink !== undefined) {
        this.rescheduleAvailable = true
      }
    },
    confirm: async function (isConfirm) {
      if (isConfirm) {
        this.lastBtnClicked = 'confirm'
        this.bgColor = this.data.setup.css.confirmBtn
      } else {
        this.lastBtnClicked = 'cancel'
        this.bgColor = this.data.setup.css.cancelBtn
      }
      this.dialogConfirm = true
      this.isLoading = true

      const result = await axios.post(`/api/${this.lastBtnClicked}`, {
        setup: this.data.setup,
        record: this.data.record
      })
      this.data.record.visitStatus =
        result.data.selectedStatus !== undefined
          ? result.data.selectedStatus : 'error'

      this.isLoading = false
    },
    makeCallout: function (url, method, body) {
      const options = { method }
      options.headers = {
        'Content-Type': 'application/json'
      }
      if (body !== undefined) {
        options.body = JSON.stringify(body)
      }
      return fetch(url, options)
        .then(response => response.json())
    }
  }

}
</script>

<style lang="scss" scoped>
#my-app {
  max-width: 768px;
  margin: auto;
  background-color: white;
  min-height: 100vh;
}
nav {
  height: auto;
  display: -webkit-box;
  display: flex;
  position: relative;
  padding-bottom: 3px;
  color: #fff;
  cursor: pointer;
}
.tab {
  width: 100%;
  -webkit-box-pack: center;
  justify-content: center;
  align-items: flex-start;
  text-align: center;

  .icon-label {
    font-size: 0.5em;
  }
  svg {
    width: 2.125em;
    height: 2.125em;
    fill: #fff;
  }

  span {
    font-size: 0.5em;
  }
}
.indicator {
  width: 33.33%;
  height: 3px;
  position: absolute;
  bottom: 0;
  background-color: #fff;
  -webkit-transition: 0.3s ease;
  transition: 0.3s ease;
}
.tab1.active ~ .indicator {
  left: 0;
}
.tab2.active ~ .indicator {
  left: 33.33%;
}
.tab3.active ~ .indicator {
  left: 66.67%;
}

.info-row {
  display: flex;
  align-items: flex-start;
  padding-bottom: 0.625em;

  svg {
    fill: black;
    width: 1.5em;
    height: 1.5em;
    padding-right: 0.625em;
  }

  span {
    line-height: 1.5em;
  }
}
input,
textarea,
button,
select,
a,
nav {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

p {
  margin: 0;
}

.tabcontent {
  background-color: #fff;
  padding: 0.625em;
}

header {
  padding: 1.25em 0;
  text-align: center;
}
h1 {
  text-align: center;
  color: #fff;
  margin: 0;
  font-weight: 300;
}
section {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
#avatar {
  border: 1px solid #fff;
  border-radius: 50%;
  width: 4em;
  height: 4em;
}
#staff-name {
  color: #fff;
  font-size: 0.75em;
  padding: 0.125em 0 0.875em 0;
}
#footer {
  max-width: 768px;
  margin: auto;
  position: fixed;
  // left: 0;
  bottom: 0;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.9);
  width: 100%;
}
.btn {
  margin: 0.625em;
  flex: 1;
  align-items: flex-start;
  text-align: center;
  color: white;
  outline: 0;
  border: 0;
  padding: 15px 20px;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}
.btn:after {
  content: '';
  background: white;
  display: block;
  position: absolute;
  padding-top: 300%;
  padding-left: 350%;
  margin-left: -20px !important;
  margin-top: -120%;
  opacity: 0;
  transition: all 0.8s;
}
.btn:active:after {
  padding: 0;
  margin: 0;
  opacity: 1;
  transition: 0s;
}
a:link, a:visited, a:hover, a:active, a {
  text-decoration: none;
}
.map-link:link, .map-link:visited, .map-link:hover, .map-link:active, .map-link {
  color: #000;
}
</style>
